<template>
  <div>
    <div class="questions-bg">
      <p class="title">{{(currentIndex+1)+"/"+questionList.length+". "+questionList[currentIndex].title}}</p>
      <div class="item-bg" :class="item.num === activeIndex?'select':''" v-for="item in questionList[currentIndex].options" :key="item.num" @click="itemSelected(item.num, questionList[currentIndex].id)">
        <p class="item-1 ">{{item.num+"."}}</p>
        <p class="item-2">{{item.option}}</p>
      </div>
    </div>
  </div>
</template>
<script>
import {getExam, getExamResult} from '../../../utils/actions'
import { showAlertBox } from '../../../utils/common'
import {mapGetters} from 'vuex'
export default {
  name: 'Answer',
  data () {
    return {
      examId: 0,
      currentIndex: 0,
      activeIndex: '',
      questionList: [{
        title: '',
        options: [
          {
            num: '',
            option: ''
          }
        ]
      }],
      answerList: {}
    }
  },
  created () {
    this.getExamInfo()
  },
  computed: {
    ...mapGetters({
      userInfo:'getUserInfo'
    })
  },
  methods: {
    getExamInfo () {
      var that = this
      var dtd = new Promise(function (resolve, reject) {
        var param = {
          method: 'driver.signup.exam',
          token: that.userInfo.token,
          id: that.userInfo.id
        }
        getExam(param).then(function (res) {
          if (res) {
            that.activeIndex = 0
            that.currentIndex = 0
            that.examId = res.data.exam_id
            that.questionList = res.data.question
            resolve()
          }
        })
      })
      return dtd
    },
    itemSelected (e, id) {
      this.activeIndex = e
      this.answerList[id] = this.activeIndex
      var that = this
      setTimeout(() => {
        if (that.currentIndex < this.questionList.length - 1) {
          that.currentIndex++
          that.activeIndex = 0
        } else {
          that.checkExamResut()
        }
      }, 200)
    },
    checkExamResut () {
      var param = {
        token:this.userInfo.token,
        id: this.userInfo.id,
        exam_id: this.examId,
        answer: JSON.stringify(this.answerList)
      }
      var that = this
      getExamResult(param).then(function (res) {
        if (res) {
          if (res.code*1 == 0) {//eslint-disable-line
            that.$emit('answerEnd', res.data)
          } else if (res.code*1 == 604 || res.code*1 == 610) {//eslint-disable-line
            showAlertBox(res.message, () => {
              that.$emit('refresh')
            })
          } else {
            alert(res.message)
          }
        } else {
          alert(res.message)
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.questions-bg{
  margin-top: 0.76rem;
  width: 95%;
  margin-left: 2.5%;
  background: #F7F7F7;
  border: 1px solid #EEEFF1;
  border-radius: 0.12rem;
  .title{
    // width: 87%;
    text-align: left;
    font-size: 0.28rem;
    color: #19191A;
    line-height: 0.36rem;
    margin: 0.48rem 0.25rem;
  }
  .item-bg{
    margin: 0 auto;
    width: 6.4rem;
    background-image: linear-gradient(269deg, #F25050 0%, #C93131 100%);
    background: #FFFFFF;
    border: 1px solid #19191A;
    border-radius: 4px;
    margin-bottom: 0.3rem;
    font-size: 0.28rem;
    color: #19191A;
    box-sizing: border-box;
    display: flex;
    align-items: flex-start;
    padding-right: 0.2rem;
    p{
      margin-top: 0.26rem;
      margin-bottom: 0.26rem;
    }
    .item-1{
      text-align: center;
      flex:1;
    }
    .item-2{
      text-align: left;
      flex:8.5;
    }
  }
  div:nth-last-of-type(1){
    margin-bottom: 0.56rem;
  }
  .select{
      background-image: linear-gradient(269deg, #F25050 0%, #C93131 100%) !important;
      color: #FFFFFF !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/recruit-answer/components/Answer.vue